import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Typography, Spin, Result, Button } from "antd";
import { DownloadOutlined, ClockCircleOutlined, PlayCircleOutlined,HomeOutlined } from "@ant-design/icons";
import { downloadVideo, getWatchVideo } from "../../services/Api/WatchVideoApi";
import "./WatchVideo.css";

const { Title, Text } = Typography;

const WatchVideo = () => {
	const { token } = useParams();
	const [status, setStatus] = useState("LOADING");
	const [data, setData] = useState(null);

	useEffect(() => {
		const fetchVideo = async () => {
			try {
				const res = await getWatchVideo(token);

				if (res?.data?.data?.status === "ACTIVE") {
					setData(res.data.data);
					setStatus("ACTIVE");
				} else {
					setStatus(res.data.data.status);
				}
			} catch (err) {
				setStatus("ERROR");
			}
		};

		fetchVideo();
	}, [token]);

	// ⏳ LOADING
	if (status === "LOADING") {
		return (
			<div className="loading-container">
				<div className="loading-content">
					<Spin size="large" />
					<p className="loading-text">Loading your video...</p>
				</div>
			</div>
		);
	}

	// ❌ INVALID
	if (status === "INVALID") {
		return (
			<div className="result-container">
				<Result
					status="404"
					title={<span className="result-title">Invalid Link</span>}
					subTitle="This video link is invalid or unauthorized."
					extra={[
						<Button
							type="primary"
							size="large"
							onClick={() => window.location.href = "https://lifeworthlivingfilm.com/"}
							key="home"
							className="result-button"
						>
							Go to Home
						</Button>,
					]}
				/>
			</div>
		);
	}

	// ⏰ EXPIRED
	if (status === "EXPIRED") {
		return (
			<div className="result-container">
				<Result
					status="warning"
					title={<span className="result-title">Link Expired</span>}
					subTitle="Your access to this video has expired. Please request a new link."
					extra={[
						<Button
							type="primary"
							size="large"
							onClick={() => window.location.href = "https://lifeworthlivingfilm.com/"}
							key="home"
							className="result-button"
						>
							Go to Home
						</Button>,
					]}
				/>
			</div>
		);
	}

	// ⚠️ ERROR
	if (status === "ERROR") {
		return (
			<div className="result-container">
				<Result
					status="500"
					title={<span className="result-title">Something went wrong</span>}
					subTitle="We encountered an error loading this video. Please try again later."
					extra={[
						<Button
							type="primary"
							size="large"
							onClick={() => window.location.reload()}
							key="retry"
							className="result-button"
						>
							Try Again
						</Button>,
					]}
				/>
			</div>
		);
	}

	// ✅ ACTIVE
	return (
		<div className="watch-video-container">
			<div className="background-gradient" />

				<Button
				className="home-button"
				icon={<HomeOutlined />}
				onClick={() => window.location.href = "https://lifeworthlivingfilm.com/"}
			>
				Home
			</Button>
			
			<Card className="video-card" bordered={false}>
				<div className="video-header">
					<PlayCircleOutlined className="header-icon" />
					<Title level={2} className="video-title">
						Life Worth Living
					</Title>
				</div>

				<div className="video-wrapper">
					<div className="video-container">
						<iframe
							src={data.video_url}
							width="100%"
							height="100%"
							allow="autoplay; fullscreen; picture-in-picture"
							allowFullScreen
							title="Life Worth Living"
						/>
					</div>
				</div>

				<div className="video-info">
					<div className="info-item">
						<ClockCircleOutlined className="info-icon" />
						<Text className="info-text">
							Access expires on{" "}
							<strong className="info-highlight">
								{new Date(data.expires_at).toLocaleDateString('en-US', {
									weekday: 'long',
									year: 'numeric',
									month: 'long',
									day: 'numeric'
								})}
							</strong>
						</Text>
					</div>

					{data.allow_download && (
						<Button
							type="primary"
							size="large"
							icon={<DownloadOutlined />}
							className="download-button"
							onClick={() => downloadVideo()}
						>
							Download Video
						</Button>
					)}
				</div>
			</Card>
		</div>
	);
};

export default WatchVideo;